import { authHeader } from '@/_helpers';
export const emailsService = {
  getAll,
  getThreadById,
  getById,
  associateOpportunity,
  associateBusinessContact,
  setValidStatus,
  replyEmail,
  sendTestEmail,
  createOpportunity,
  updateTemplate,
  getAllTemplates,
  getTemplate,
  getAgencyEmails,
  getNylasEmails,
  getNylasEmail,
  getNylasEmailsList,
  emailDone,
  reTagEmail
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function getAll(currentPage, cantPerPage, searchFilter, salesUserFilter) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json')
  };
  return fetch(`${apiUrl}/email-response/filtered-list?currentPage=${currentPage}&cantPerPage=${cantPerPage}&searchFilter=${searchFilter}&userFilter=${salesUserFilter}`, requestOptions).then(handleResponse);
}


function getAgencyEmails() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({})
  };

  return fetch(`${apiUrl}/clients/get-agency-list`, requestOptions).then(handleResponse);
}

function emailDone(email_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({email_id})
  };

  return fetch(`${apiUrl}/clients/emaildone`, requestOptions).then(handleResponse);
}


function getNylasEmail(client_nylas_id,email_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({client_nylas_id, email_id})
  };

  return fetch(`${apiUrl}/clients/get-email`, requestOptions).then(handleResponse);
}


function getNylasEmails(emailkey, currentPage, cantPerPage) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({emailkey, currentPage, cantPerPage})
  };

  return fetch(`${apiUrl}/clients/get-antispam`, requestOptions).then(handleResponse);
}

function getNylasEmailsList(done) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({done})
  };

  return fetch(`${apiUrl}/clients/get-antispam-list`, requestOptions).then(handleResponse);
}


function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json')
  };
  return fetch(`${apiUrl}/email-response/${id}`, requestOptions)
    .then(handleResponse)
    .then(message => decodeMessage(message));
}

function decodeMessage(message) {

  return message;
}

function getThreadById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json')
  };
  return fetch(`${apiUrl}/email-response/${id}/thread`, requestOptions).then(handleResponse);
}

function replyEmail(email, image) {
  let formData = new FormData();
  formData.append('image', image);
  formData.append('email', JSON.stringify(email));

  const requestOptions = {
    method: 'POST',
    headers: authHeader(null),
    body: formData
  };

  // const requestOptions = {
  //     method: 'POST',
  //     headers: authHeader('application/json'),
  //     body: JSON.stringify(email)
  // };

  return fetch(`${apiUrl}/email-sent/`, requestOptions).then(handleResponse);
}

function sendTestEmail(campaign, testBusinessContactSelected) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ campaign: campaign, testBusinessContactSelected: testBusinessContactSelected })
  };

  return fetch(`${apiUrl}/email-sent/test`, requestOptions).then(handleResponse);
}

function associateOpportunity(id, oppotunity) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(oppotunity)
  };

  return fetch(`${apiUrl}/email-response/${id}/associateOpportunity`, requestOptions).then(handleResponse);
}

function associateBusinessContact(id, business_contact) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(business_contact)
  };

  return fetch(`${apiUrl}/email-response/${id}/associateBusinessContact`, requestOptions).then(handleResponse);
}

function setValidStatus(id, status_id, message) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      email_response_status_id: status_id,
      message: message,
    })
  };

  return fetch(`${apiUrl}/email-response/${id}/status`, requestOptions).then(handleResponse);
}

function createOpportunity(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
  };
  return fetch(`${apiUrl}/email-response/${id}/create-opportunity`, requestOptions).then(handleResponse);
}

function updateTemplate(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      data
    })
  };
  return fetch(`${apiUrl}/email-template/`, requestOptions).then(handleResponse);
}

function getAllTemplates(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      data
    })
  };
  return fetch(`${apiUrl}/email-template/filtered-list`, requestOptions).then(handleResponse);
}

function getTemplate(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  return fetch(`${apiUrl}/email-template/${id}`, requestOptions).then(handleResponse);
}

function reTagEmail(id,link_id,business_contact_id,email_response_id){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      id,link_id,business_contact_id,email_response_id
    })
  };
  return fetch(`${apiUrl}/email-response/tag`, requestOptions).then(handleResponse);
}


function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = data || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}